import {createSlice} from '@reduxjs/toolkit';

const initialState = {
  filters: {
    State: [],
    Branch: [],
    CreatedBy: [],
  },
  selectedProduct: '',
};

const filterValue = createSlice({
  name: 'filterValue',
  initialState,
  reducers: {
    setFilterValue: (state, action) => {
      const {filters} = action.payload;

      state.filters = {
        ...state.filters,
        ...filters,
      };
    },

    setSelectedProduct: (state, action) => {
      state.selectedProduct = action.payload;
    },

    resetFiltersOnly: (state) => {
      state.filters = {
        State: [],
        Branch: [],
        CreatedBy: [],
      };
    },

    resetFilterValue: () => initialState,
  },
});

export const {setFilterValue, setSelectedProduct, resetFiltersOnly, resetFilterValue} = filterValue.actions;

export default filterValue.reducer;
